import styled, { css } from 'styled-components';

import { LifeAreaColumnType } from '../../types';

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  width: 100%;

  background: ${({ theme }) => theme.palette.background.default};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => `0 ${theme.spacing(4)} 0 ${theme.spacing(5)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
`;

export const Item = styled.div<{ $column: LifeAreaColumnType }>`
  flex: 0 0 auto;

  ${({ $column }) => {
    switch ($column) {
      case LifeAreaColumnType.Name:
        return css`
          flex: 1;
        `;
      case LifeAreaColumnType.Vision:
        return css`
          flex: 1;
          min-width: 0;
          display: none;

          @container life-area-list (min-width: 60rem) {
            display: block;
          }
        `;
      case LifeAreaColumnType.Goals:
        return css`
          width: 6.4rem;
        `;
      case LifeAreaColumnType.Projects:
        return css`
          width: 6.4rem;
          display: none;

          @container life-area-list (min-width: 45rem) {
            display: block;
          }
        `;
    }
  }}
`;

export const Button = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1.5)} 0`};
  background: transparent;

  border: none;
  cursor: pointer;
  transition: color 200ms;

  text-align: left;
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $active, theme }) =>
    $active &&
    css`
      color: ${theme.palette.text.primary};
    `}

  &:hover {
    ${({ $active }) =>
      !$active &&
      css`
        opacity: 0.8;
      `}
  }
`;

export const DirectionIcon = styled.span<{ $desc: boolean }>`
  display: flex;
  align-items: center;

  font-size: 1.2rem;
  line-height: 62.5%;

  transition: transform 200ms;
  transform: rotate(${({ $desc }) => ($desc ? '180deg' : '0deg')});
`;
